<div coreTitle i18n>Home</div>

<h3 i18n>Welcome to ADKOM</h3>
<p i18n>Please wait while we redirect you to your personal dashboard ...</p>
